import { render, staticRenderFns } from "./UpdateRecordList.vue?vue&type=template&id=751b952b&"
import script from "./UpdateRecordList.vue?vue&type=script&lang=js&"
export * from "./UpdateRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports